<!--
 * @Descripttion: 
 * @version: 
 * @Author: Raoxf
 * @Date: 2021-04-06 14:14:46
 * @LastEditors: Raoxf
 * @LastEditTime: 2022-05-28 22:02:45
-->
<template>
  <div class="router_container">
    <Header />
    <Sider />
    <section class="router-content">
      <div class="wrap_router">
        <transition name="fade" mode="out-in">
          <!-- <keep-alive></keep-alive> -->
          <router-view />
        </transition>
      </div>
    </section>
  </div>
</template>
<script>
import Header from "@compoents/Header.vue";
import Sider from "@compoents/Sider.vue";
// import TabNav from "@compoents/Header.vue";
export default {
  components: {
    Header,
    Sider,
    // TabNav
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.router_container {
  height: 100%;
  width: 100%;
  background-color: rgb(240, 242, 245);
}
.router-content {
  padding: 99px 15px 15px 210px;
  height: 100%;
  overflow: hidden;
  .wrap_router {
    height: 100%;
    padding: 25px 0;
    border-radius: 6px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    background: #fff;
    overflow-y: scroll;
  }
}
</style>
